import React from 'react';
import PageContainer from "../../../../hoc/PageContainer";
import './BreakingGuinnessWR.css';

const BreakingGuinessWR = () =>(
    <div>
        <PageContainer page="ourServices">
            <h1 className="AboutUsTitle">
                我和唐寶寶有個約會 : 千人合奏非洲鼓 與唐寶寶齊破健力士世界紀錄
            </h1>

            <div className="our-services-video-container">
                <iframe width="854" height="480" src="https://www.youtube.com/embed/r4bDyLtlpAM" frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
            </div>

            <div className="AboutUsText">
                <p>
                    活動理念: 唐氏綜合症人士基於染色體與一般人不同，故此在各項成長發展上需要比一般人付出更多努力去挑戰各種障礙，而且他們的照顧者亦需要付出加倍的精神和愛護。然而，唐氏綜合症人士也有很多不同的潛能，只要適當地給予培訓及加上社會的支持，他們也可以發展潛能！同時，照顧者勇敢陪伴唐氏綜合症人士一同渡過人生不同階段和面對不同挑戰，所發揮的正面能量和積極態度也非常值得社會尊敬！

                    我和唐寶寶有個約會 — “挑戰健力士世界紀錄：最多人合奏非洲鼓” 由超過一千名義工、香港唐氏綜合症協會的會員及其照顧者組合而成，共同合力奏非洲鼓挑戰健力士世界紀錄，藉著熱情的非洲鼓樂及共融合奏的方式，鼓動社會大眾一起關注唐氏綜合症人士的正向潛能及其照顧者的堅毅不屈的精神。
                </p>

                <img id="guinness-wr-img" src="/imgs/wr/1.jpg"/>
                <img id="guinness-wr-img" src="/imgs/wr/2.jpg"/>

                <p>
                    藉著熱情的非洲鼓樂同共融合奏的方式，配合簡單的舞蹈動作和口號，最終由978人及以６分鐘節拍不斷的鼓聲，成功刷新最多人合奏非洲鼓健力士世界紀錄，鼓動社會大眾一齊關注唐氏綜合症人士的正向潛能以及其照顧者既堅毅不屈的精神，實行關懷唐氏、鼓動潛能、千人鼓動、社會共融的活動目的。
                </p>
                <img id="guinness-wr-img" src="/imgs/wr/3.jpg"/>

            </div>


        </PageContainer>
    </div>
);

export default BreakingGuinessWR;
